export class ChangePasswordRequest {
    constructor(
        public username: string,
        public currentPassword: string,
        public newPassword: string,
        public confirmPassword: string,
        public captchaCode?: string
    ) {
    }
}